import { nb } from 'date-fns/locale'
import { formatInTimeZone } from 'date-fns-tz'

export function getArticleInfo() {
  if (document.querySelector('article.dh-sa-article')) {
    // Hent informasjon fra Stilbar Artikkel
    return {
      authors: getSAAuthors(),
      publishedStrings: getSAPublishedStrings(),
    }
  }

  // Default XL-article or feature with similar setup
  return {
    authors: getXLAuthors(),
    publishedStrings: getXLPublishedStrings(),
  }
}

function getLinkedData() {
  const element = document.querySelector('script[type="application/ld+json"]') as
    | HTMLElement
    | undefined
  return element ? JSON.parse(element?.innerText) : {}
}

function getXLAuthors() {
  return Array.from(document.querySelectorAll('.author__body')).map((authorElm) => {
    const authNameElm = authorElm.querySelector('.author__name') as HTMLAnchorElement
    const authRoleElm = authorElm.querySelector('.author__role')
    return {
      name: Array.from(authNameElm.childNodes ?? [])
        .filter((n) => n.nodeName === '#text')
        .map((n) => n.textContent)
        .join('')
        .trim(),
      href: authNameElm.href,
      role: authRoleElm.textContent,
    }
  })
}

function formatDate(date) {
  return formatInTimeZone(date, 'Europe/Oslo', `dd. MMM yyyy 'KL.' HH:mm`, { locale: nb })
}

function getXLPublishedStrings() {
  const { datePublished } = getLinkedData()
  const meta = document.querySelector('meta[property="article:modified_time"]')
  const dateModified = meta?.getAttribute('content')
  if (!datePublished) {
    return ['']
  }
  if (!dateModified || dateModified === datePublished) {
    return [`Publisert ${formatDate(datePublished)}`]
  }
  return [`Publisert ${formatDate(datePublished)}`, `Oppdatert ${formatDate(dateModified)}`]
}

function getSAAuthors() {
  const articleInfo = getLinkedData()
  return (
    articleInfo?.author?.map((author: any) => {
      return {
        name: author.name,
        href: author.email ? `mailto:${author.email}` : undefined,
        role: author.role,
      }
    }) ?? []
  )
}

function getSAPublishedStrings() {
  const articleInfo = getLinkedData()
  if (!articleInfo?.datePublished) {
    return ['']
  }

  const formattedDate = new Intl.DateTimeFormat('no', {
    dateStyle: 'medium',
    timeZone: 'CET',
  }).format(new Date(articleInfo?.datePublished))

  return [`Publisert ${formattedDate}`]
}
